/* LVT Flooring Direct — motion layer.
   Native browser scrolling is preserved (no smooth-scroll hijacking). GSAP is
   used ONLY for effects that read the real scroll position and never intercept
   input: fade-in reveals (IntersectionObserver, no GSAP dependency) and a
   subtle hero parallax. Skipped in the theme editor and for reduced-motion. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  if (reducedMotion || designMode) return;

  /* ── Reveal-on-scroll: IntersectionObserver + failsafe ─────────────── */
  var sections = Array.prototype.slice.call(
    document.querySelectorAll('#MainContent > .shopify-section')
  );
  var toReveal = [];
  sections.forEach(function (sec, i) {
    if (i === 0) return; // never touch the hero / LCP
    if (sec.querySelector('.product-grid, main-collection, .facets, [data-testid="product-grid"]')) return;
    sec.classList.add('lvt-pre');
    toReveal.push(sec);
  });

  var revealAll = function () {
    toReveal.forEach(function (el) { el.classList.add('lvt-in'); });
  };

  if ('IntersectionObserver' in window && toReveal.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('lvt-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    toReveal.forEach(function (el) { io.observe(el); });
  } else {
    revealAll();
  }
  /* Failsafe: whatever happens, nothing stays hidden */
  setTimeout(revealAll, 2500);

  /* ── Hero parallax (native scroll, does not hijack input) ──────────── */
  if (!window.gsap || !window.ScrollTrigger) return;
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  if (!finePointer) return;

  gsap.registerPlugin(ScrollTrigger);
  var hero = sections[0];
  var heroMedia = hero && hero.querySelector('img, video');
  if (heroMedia) {
    if (heroMedia.parentElement) { heroMedia.parentElement.style.overflow = 'hidden'; }
    gsap.to(heroMedia, {
      yPercent: 10,
      scale: 1.05,
      ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
  }
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();

/* ── Adhesive reminder before checkout ─────────────────────────────
   The cart drawer re-renders (morphs) its markup whenever the cart changes,
   which drops element-bound listeners and never executes inline scripts, so
   this is delegated from document and lives in a globally loaded file. The
   prompt element itself is rendered by snippets/cart-summary.liquid, which
   decides server-side whether it is needed (flooring in cart, no adhesive). */
(function () {
  if (window.__lvtGluePrompt) return;
  window.__lvtGluePrompt = true;

  function promptFor(checkoutBtn) {
    var ctas = checkoutBtn.closest('.cart__ctas');
    if (!ctas || !ctas.parentElement) return null;
    var prompt = ctas.parentElement.querySelector('[data-glue-prompt]');
    return prompt ? { ctas: ctas, prompt: prompt } : null;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;

      var yes = e.target.closest('[data-glue-yes]');
      if (yes) {
        var prompt = yes.closest('[data-glue-prompt]');
        var ctas = prompt && prompt.parentElement.querySelector('.cart__ctas');
        if (!ctas) return;
        prompt.dataset.confirmed = '1';
        prompt.hidden = true;
        ctas.hidden = false;
        var btn = ctas.querySelector('button[name="checkout"]');
        if (btn) btn.click();
        return;
      }

      var checkout = e.target.closest('button[name="checkout"]');
      if (!checkout) return;
      var parts = promptFor(checkout);
      if (!parts || parts.prompt.dataset.confirmed === '1') return;

      e.preventDefault();
      e.stopPropagation();
      parts.prompt.hidden = false;
      parts.ctas.hidden = true;
      var focusable = parts.prompt.querySelector('[data-glue-yes]');
      if (focusable) focusable.focus();
    },
    true
  );
})();

/* ── Back to top ───────────────────────────────────────────────────
   Built in JS so no theme section has to carry the markup. The page
   scrolls inside .page-wrapper on desktop and the window on mobile, so
   whichever is actually scrolling is the one we listen to and move. */
(function () {
  if (window.__lvtBackToTop) return;
  window.__lvtBackToTop = true;

  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('.page-wrapper');
    var scroller = wrapper && getComputedStyle(wrapper).overflowY === 'auto' ? wrapper : window;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lvt-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(btn);

    var ticking = false;
    function currentTop() {
      return scroller === window ? window.scrollY || document.documentElement.scrollTop : scroller.scrollTop;
    }
    function update() {
      btn.classList.toggle('is-visible', currentTop() > window.innerHeight * 0.8);
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    (scroller === window ? window : scroller).addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var opts = { top: 0, behavior: smooth ? 'smooth' : 'auto' };
      if (scroller === window) window.scrollTo(opts);
      else scroller.scrollTo(opts);
    });
    update();
  });
})();

/* ── Mega menu alignment ───────────────────────────────────────────
   Horizon's mega menu panel spans the full window, so its links start
   at the page edge rather than under the item that opened them. This
   measures each item's offset and hands it to CSS. Recalculated on
   open, because the header reflows (sticky, logo size, zoom). */
(function () {
  if (window.__lvtMegaAlign) return;
  window.__lvtMegaAlign = true;

  function align(item) {
    var submenu = item.querySelector(':scope > .menu-list__submenu');
    if (!submenu) return;
    var list = submenu.querySelector('.mega-menu__list');
    if (!list) return;
    var grid = list.closest('.mega-menu__grid') || submenu;
    var offset = item.getBoundingClientRect().left - grid.getBoundingClientRect().left;
    submenu.style.setProperty('--lvt-mega-offset', Math.max(0, Math.round(offset)) + 'px');
  }

  function bind() {
    var items = document.querySelectorAll('.menu-list__list-item:has(.menu-list__submenu)');
    items.forEach(function (item) {
      if (item.dataset.lvtAligned) return;
      item.dataset.lvtAligned = '1';
      ['mouseenter', 'focusin'].forEach(function (evt) {
        item.addEventListener(evt, function () { align(item); });
      });
      align(item);
    });
  }

  document.addEventListener('DOMContentLoaded', bind);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.menu-list__list-item[data-lvt-aligned]').forEach(align);
  });
  // The header re-renders on some navigations; pick up new items when it does.
  if (window.MutationObserver) {
    new MutationObserver(bind).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
